import { render, staticRenderFns } from "./MediaView.vue?vue&type=template&id=bfc85714&scoped=true&"
import script from "./MediaView.vue?vue&type=script&lang=js&"
export * from "./MediaView.vue?vue&type=script&lang=js&"
import style0 from "./MediaView.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MediaView.vue?vue&type=style&index=1&id=bfc85714&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc85714",
  null
  
)

export default component.exports